import { useEffect, useState } from 'react';
import api from '../api';
import { useApp } from '../App';

export default function OfferDetails() {
  const { setPage } = useApp();
  const [offer, setOffer] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const offerId = Number(localStorage.getItem('marketplace_offer_id') || 0);

  useEffect(() => {
    if (!offerId) {
      setError('Оффер не выбран');
      setLoading(false);
      return;
    }
    loadOffer();
  }, [offerId]);

  async function loadOffer() {
    try {
      setLoading(true);
      const { data } = await api.get(`/marketplace/offers/${offerId}`);
      setOffer(data);
    } catch (e) {
      setError(e.userMessage || 'Не удалось загрузить оффер');
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div className="card">Загрузка...</div>;
  if (error) return <div className="card" style={{ color: '#ef4444' }}>{error}</div>;
  if (!offer) return <div className="card">Оффер не найден</div>;

  return (
    <div>
      <div className="page-header">Offer details</div>
      <div className="card">
        <div style={{ fontSize: 20, fontWeight: 800 }}>{offer.title}</div>
        <div style={{ marginTop: 8, opacity: 0.8 }}>{offer.description || 'Без описания'}</div>
        <div style={{ marginTop: 12 }}>Бюджет: <b>{offer.budget_amount} {offer.currency}</b></div>
        <div style={{ marginTop: 6 }}>Комиссия: <b>{offer.commission_type === 'percent' ? `${offer.commission_rate}%` : `${offer.commission_flat_amount || 0} ${offer.currency}`}</b></div>
        <div style={{ marginTop: 6 }}>Settlement: <span className="badge badge-issued">{offer.settlement_status}</span></div>

        <div style={{ marginTop: 14, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button className="btn" onClick={() => setPage('offers')}>← Назад</button>
          <button className="btn" onClick={() => window.open('https://genro.ai', '_blank', 'noopener,noreferrer')}>Open in Genro AI</button>
          <button className="btn btn-primary" onClick={() => setPage('offer_accept')}>Process in Workify CRM</button>
        </div>
      </div>
    </div>
  );
}
